import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link, useLocation, useHistory } from "react-router-dom"
import { Box, Grid, Typography, Tooltip } from "@material-ui/core"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import {
	getFileRowClickRequest,
	getFileRequestByPage,
	getPageNumberBasedOnHighlightTextRequest,
} from "../../../actions/documentModalActions"
import { getAnnotation, getAuditHistory, getChat, updateCurrentSession, updateViewerPageNumber } from "../../../actions/viewerActions"
import { getReviewBasedOnFileIdRequest } from "../../../actions/reviewActions"
import { searchHighlightFilter } from "../../../actions/highlightActions"
import { checkToShowNativeFormat } from "../../../utils"
import { getInfo } from "../../../actions/infoActions"

const useStyles = makeStyles((theme) => ({
	metaDetails: {
		paddingLeft: "12px",
		paddingRight: "12px",
		// height: `calc(40vh + 50px)`,
		height: "42vh",
		overflow: "auto",
		"& .MuiTypography-root": {
			...theme.typography.body2,
			paddingBottom: "15px",
			paddingRight: "8px",
			wordBreak: "break-word",
		},
	},
}))

function Details(props) {
	const theme = useTheme()
	const classes = useStyles()
	const location = useLocation()
	const dispatch = useDispatch()
	const history = useHistory()
	const highlightFilter = useSelector((state) => state.highlightFilter.search)
	const aiEnabled = useSelector((state) => state?.info?.version?.ai_enabled)
	const [data, setData] = useState([])
	const { getDetailsData } = props

	useEffect(() => {
		const data = getDetailsData()
		if (data) {
			setData(data)
		} else {
			console.log("data not found")
		}
	}, [getDetailsData])

	const getPageNumberBasedOnHighlightText = () => {
		const params = location?.pathname?.split("/")
		const fileId = params[params.length - 1]
		if (highlightFilter["specificWord"] || highlightFilter["concepts"]) {
			let searchText = highlightFilter["specificWord"] ? highlightFilter?.searchWord : []
			let selectedConcept = highlightFilter["concepts"] ? highlightFilter?.loadedConcept : []
			const payload = {
				categories: props?.retainedFilterJobData?.categories || [],
				text: [...searchText, ...selectedConcept],
				return_count: 20000,
				skip_count: 0,
				suppress_content: false,
				neg_text: "",
				mode: "PAGE",
				treat_like_concept: false,
				selected_database: props?.retainedFilterJobData?.selected_database,
				additional_params: {
					skip_audit: true,
					page_context: params?.[1],
				},
				restrict_file_ids: [fileId],
			}
			dispatch(getPageNumberBasedOnHighlightTextRequest(payload))
		}
	}

	return (
		<Box className={classes.metaDetails}>
			<Grid container direction="column">
				{data?.length > 0 &&
					data?.map((item, index) => {
						return (
							<Grid container key={`details-${index}`}>
								<Grid item xs={4}>
									<Typography style={{ color: theme.palette.grey["D100"] }}>{item?.title}</Typography>
								</Grid>
								<Grid item xs={8}>
									{!(item?.attachment || item?.emailRef) && item?.isTooltip && (
										<Tooltip
											title={Array.isArray(item?.value) ? item?.value?.toString() : item?.value}
											placement="top-start"
										>
											<Typography noWrap>
												{Array.isArray(item?.value) ? item?.value?.toString() : item?.value}
											</Typography>
										</Tooltip>
									)}
									{!(item?.attachment || item?.emailRef) && !item?.isTooltip && (
										<Typography>{Array.isArray(item?.value) ? item?.value?.toString() : item?.value}</Typography>
									)}
									{item?.attachment &&
										item?.value?.map((attachment, index) => {
											return (
												<Tooltip title={attachment?.name} placement="top">
													<Typography noWrap>
														<Link
															to={{
																pathname: `${attachment?.file_id}`,
																search: window?.location?.search,
																state: { prevPath: location?.state?.prevPath },
															}}
															onClick={() => {
																dispatch(getFileRowClickRequest(attachment?.file_id))
																dispatch(
																	getFileRequestByPage({
																		id: attachment?.file_id,
																		page: 1,
																		reviewId:
																			props?.retainedFilterJobData?.additional_params?.review_id,
																	})
																)
																dispatch(updateViewerPageNumber(1))
																dispatch(getAuditHistory(attachment?.file_id))
																dispatch(
																	getAnnotation(
																		attachment?.file_id,
																		checkToShowNativeFormat(attachment?.metatdata)
																	)
																)
																getPageNumberBasedOnHighlightText()
																const filterData = { ...highlightFilter }
																filterData["nativeView"] = true
																dispatch(searchHighlightFilter(filterData))
															}}
														>
															{attachment?.name}
														</Link>
													</Typography>
												</Tooltip>
											)
										})}
									{item?.emailRef && (
										<Tooltip title={item?.value} placement="top">
											<Typography noWrap>
												<Link
													to={{
														pathname: `${item?.fileId}`,
														state: { prevPath: location?.state?.prevPath },
														search: window?.location?.search,
													}}
													onClick={() => {
														dispatch(getFileRowClickRequest(item?.fileId))
														dispatch(
															getFileRequestByPage({
																id: item?.fileId,
																page: 1,
																reviewId: props?.retainedFilterJobData?.additional_params?.review_id,
															})
														)
														dispatch(updateViewerPageNumber(1))
														dispatch(getAuditHistory(item?.fileId))
														dispatch(getAnnotation(item?.fileId))
														const chatPayload = {
															file_ids: [item?.fileId],
														}
														if (aiEnabled) {
															dispatch(getChat(chatPayload))
														}
														dispatch(updateCurrentSession(0))
														dispatch(getReviewBasedOnFileIdRequest(item?.fileId))
														getPageNumberBasedOnHighlightText()
														const filterData = { ...highlightFilter }
														filterData["nativeView"] = true
														dispatch(searchHighlightFilter(filterData))
													}}
												>
													{item?.value}
												</Link>
											</Typography>
										</Tooltip>
									)}
								</Grid>
							</Grid>
						)
					})}
			</Grid>
		</Box>
	)
}

export default Details
